module.exports = __webpack_public_path__ + "static/media/vail-3.7d55ebb1.jpg";